// Autogenerated file
export const universalDocumentSystemsEnum = {
    Internal: "Internal",
    KonturDiadoc: "KonturDiadoc",
};
export const universalDocumentSystems = [
    { label: "CARGO.RUN", value: "Internal" },
    { label: "Контур.Диадок", value: "KonturDiadoc" },
];
